module.exports = "<div class=\"site-maintain\">\n  <article>\n    <h1>Site is temporarily unavailable.</h1>\n    <hr>\n    <p>Scheduled maintenance is currently in progress. Please check back soon.</p>\n    <p>We apologize for any inconvenience.</p>\n    <p id=\"signature\">&mdash; <a href=\"javascript:void(0)\">Creditup Club</a></p>\n  </article>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /Users/hrushabhmakwana/Documents/CAM/CreditRepairMenAngular/src/app/site-maintenance/site-maintenance.component.html
// module id = ../../../../../src/app/site-maintenance/site-maintenance.component.html
// module chunks = main